import React, { useMemo } from "react";
import Highcharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import "highcharts/highcharts-more";
import "highcharts/modules/exporting";
import { getChartColor } from "../../config/colors";


const PieChart = ({ inProgressData }) => {
  const chartData = Array.isArray(inProgressData)
    ? inProgressData.map((item) => ({
        name: item.class_name,
        y: item.inprogress_count,
        color: getChartColor(item.class_name), // Use the centralized function
      }))
    : [];

    const options = useMemo(() => ({
      chart: {
        type: "pie",
        height: 300,
      },
      exporting: {
        enabled: false,
      },
      title: {
        text: null,
      },
      tooltip: {
        pointFormat: "<b>{point.percentage:.0f}%</b>",
      },
      credits: {
        enabled: false,
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: "pointer",
          dataLabels: {
            enabled: true,
            formatter: function () {
              if (this.percentage > 0) {
                return `
                  <b style="font-size: 20px;">${this.percentage.toFixed(0)}%</b>
                  <br/>Class: ${this.point.name}
                  <br/>Total: ${this.y}
                `;
              }
              return null;
            },
            style: {
              fontSize: "12px",
              fontWeight: "bold",
              color: "black",
              textOutline: "none",
            },
            connectorWidth: 1,
          },
        
        },
      },
      series: [
        {
          name: "In Progress Batch Count",
          colorByPoint: true,
          data: chartData,
        },
      ],
    }), [inProgressData]);

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default PieChart;